import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { styled, keyframes } from '@mui/material/styles';
import * as userIDService from '../../../services/apiUsers';
import {
  Backdrop,
  Button,
  CircularProgress,
  Grid,
  Paper,
  TextField,
  Typography,
  Box,
  InputAdornment,
  Container,
  Fade,
} from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import Cookies from 'js-cookie';
import images from '../../../assets/images';
import { getCookie, setCookie } from '../../../utils/helper';
import { checkLoginUsers } from '../../../services/apiUsersCtv';

// Hiệu ứng trôi nổi nhẹ cho Logo
const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
  filter: 'drop-shadow(0px 4px 8px rgba(0,0,0,0.1))',
});

// Custom TextField để trông hiện đại hơn
const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: '14px',
    transition: 'all 0.3s ease',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    '&:hover': {
      backgroundColor: '#fff',
      boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
    },
    '&.Mui-focused': {
      backgroundColor: '#fff',
      boxShadow: '0 4px 20px rgba(211, 47, 47, 0.15)',
    },
    '& fieldset': {
      borderColor: '#eee',
    },
  },
});

function Login() {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [errorLogin, setErrorLogin] = useState('');
  const [loadingLogin, setLoadingLogin] = useState(true);
  let inFifteenMinutes = new Date(new Date().getTime() + 60 * 60 * 24 * 3 * 1000);
  const navigate = useNavigate();
  const hostname = window.location.hostname;

  const handleSubmit = async () => {
    setLoadingLogin(true);
    const dataUser = { user, pass, domain: hostname };
    const checkLogin = await userIDService.checkLoginUsers(dataUser);

    if (checkLogin.totalRow > 0) {
      setLoadingLogin(false);
      Cookies.set('token_sv', checkLogin['token'], { expires: inFifteenMinutes });
      setCookie('exp_sv', inFifteenMinutes, { expires: inFifteenMinutes });
      setCookie('token', checkLogin['data'], { expires: inFifteenMinutes });
      window.location.href = '/dashboard';
    } else {
      const checkLoginCtv = await checkLoginUsers(dataUser);
      if (checkLoginCtv.totalRow > 0) {
        setLoadingLogin(false);
        Cookies.set('token_sv', checkLoginCtv['token'], { expires: inFifteenMinutes });
        setCookie('exp_sv', inFifteenMinutes, { expires: inFifteenMinutes });
        setCookie('token', checkLoginCtv['data'], { expires: inFifteenMinutes });
        window.location.href = '/dashboard';
      } else {
        setErrorLogin('Tài khoản hoặc mật khẩu không chính xác');
        setLoadingLogin(false);
      }
    }
  };

  useEffect(() => {
    document.title = 'Hệ Thống Đăng Nhập';
    const token = getCookie('token');
    if (token) {
      window.location.href = '/dashboard';
    } else {
      setLoadingLogin(false);
    }
  }, []);

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #fff5f5 0%, #fed7d7 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          width: 500,
          height: 500,
          borderRadius: '50%',
          background: 'rgba(229, 62, 62, 0.05)',
          top: -200,
          left: -100,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          width: 300,
          height: 300,
          borderRadius: '50%',
          background: 'rgba(229, 62, 62, 0.03)',
          bottom: -100,
          right: -50,
        }}
      />

      <Container maxWidth="xs">
        <Fade in={true} timeout={1000}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 4, md: 6 },
              borderRadius: '32px',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(20px)',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.08)',
              border: '1px solid rgba(255, 255, 255, 0.4)',
              textAlign: 'center',
            }}
          >
            <Box sx={{ mb: 5, animation: `${float} 4s ease-in-out infinite` }}>
              <Box
                sx={{
                  width: 100,
                  height: 100,
                  margin: '0 auto 20px',
                  p: 0.5,
                  borderRadius: '50px',
                  background: '#faf0b8',
                  boxShadow: '0 15px 30px rgba(229, 62, 62, 0.15)',
                }}
              >
                <Img alt="logo" sx={{ borderRadius: '50px' }} src={images.logokhoso} />
              </Box>
              <Typography
                variant="h5"
                sx={{ fontWeight: 900, color: '#c53030', letterSpacing: '1px', fontFamily: 'UTM-Avo' }}
              >
                KHO SỐ PANEL
              </Typography>
              <Box sx={{ width: 40, height: 4, bgcolor: '#f56565', margin: '10px auto', borderRadius: 2 }} />
            </Box>

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <StyledTextField
                  fullWidth
                  label="Tài khoản"
                  placeholder="Nhập tài khoản..." // Đã thêm placeholder
                  value={user}
                  onChange={(e) => setUser(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon sx={{ color: '#e53e3e' }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <StyledTextField
                  fullWidth
                  label="Mật khẩu"
                  placeholder="Nhập mật khẩu..." // Đã thêm placeholder
                  type="password"
                  value={pass}
                  onChange={(e) => setPass(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon sx={{ color: '#e53e3e' }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              {errorLogin && (
                <Grid item xs={12}>
                  <Typography sx={{ color: '#c53030', fontSize: '0.85rem', fontWeight: 600 }}>{errorLogin}</Typography>
                </Grid>
              )}

              <Grid item xs={12} sx={{ mt: 1 }}>
                <Button
                  fullWidth
                  size="large"
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={loadingLogin}
                  sx={{
                    py: 1,
                    borderRadius: '16px',
                    background: 'linear-gradient(135deg, #e53e3e 0%, #9b2c2c 100%)',
                    textTransform: 'none',
                    fontSize: '1rem',
                    fontWeight: 700,
                    boxShadow: '0 10px 25px rgba(229, 62, 62, 0.3)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 15px 30px rgba(229, 62, 62, 0.4)',
                    },
                    fontFamily: 'UTM-Avo',
                  }}
                  endIcon={!loadingLogin && <LoginIcon />}
                >
                  {loadingLogin ? <CircularProgress size={24} color="inherit" /> : 'Đăng Nhập Hệ Thống'}
                </Button>
              </Grid>
            </Grid>

            <Typography variant="body2" sx={{ mt: 4, color: '#a0aec0', fontWeight: 500 }}>
              Sản phẩm thuộc hệ thống Kho Số
            </Typography>
          </Paper>
        </Fade>
      </Container>

      <Backdrop sx={{ color: '#fff', zIndex: 9999 }} open={loadingLogin}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}

export default Login;
